import React, { useState, useEffect, useMemo, useContext } from "react";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import * as FileSaver from "file-saver";
import swal from "sweetalert";
import COSInvoiceTabel from "./COSInvoicePreviewTabel";
import SelectOption from "components/common/Select/Select";
import SelectBox from "components/common/DropDownWithIocns/DropDown";
import SideBar from "components/common/SideBar/SideBarNew";
import TableHeader from "components/common/Table/TableHeader";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import Header from "components/common/Header/Header";
import Breadcrumb from "components/common/Breadcrumb";
import { LoginContext } from "helpers/LoginContext";
import api from "store/services/ah.services";

import {
  AH_BREADCRUMB,
  AH_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import { LOADER_STATUS, USER_ROLE } from "Constants/constant";
import { roleAccess } from "helpers/RolesPermission";
import CheckBox from "components/common/checkBox/checkbox";
import useCareLabels from "hooks/useCareLabels";

const COSInvoicePreviewPage = (props) => {
  const {
    changeCaseNotesInvoiceStatusSuccess,
    changeNDISCaseNotesInvoiceStatusLoading,
    createdCosInvoiceReviewLoading,
    createdCosReviewInvoiceDeliveryStatus,
    createdCosReviewInvoiceClients,
    createdCosRiviewInvoice,
    changeInvoiceStatus,
    getInvoicesList,
    getCosInvoiceMode,
    cosInvoiceMode,
    cosInvoiceLoading,
    getClientsRequest,
    emptyTableData,
  } = props;

  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const { participantLabel } = useCareLabels();
  const navigate = useNavigate();
  const isWorkerBlackPortal = roleAccess([USER_ROLE.Sp_Standard_User]);
  const isOldBatch = cosInvoiceMode === "old";
  const [renderLoading, setRenderLoading] = useState(LOADER_STATUS.NA);
  const [selectedClient, setSelectedClient] = useState(null);
  const [statusSelect, setStatus] = useState(null);

  const { uuid } = useParams();
  const [checkboxes, setCheckboxes] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [updatedAction, setUpdatedAction] = useState(null);
  const [fileDownloaderLoader, setFileDownloaderLoader] = useState(false);
  const [clientHoursReport, setClientHoursReport] = useState(false);
  const [cosHoursReport, setCosHoursReport] = useState(false);

  const createdCosRiviewInvoiceToMap = useMemo(() => {
    if (createdCosRiviewInvoice && createdCosRiviewInvoice.length > 0) {
      return createdCosRiviewInvoice;
    }
    return [];
  }, [createdCosRiviewInvoice]);

  const handleCheckboxChange = (e, id) => {
    const filteredList = checkboxes.filter((c) => c !== id);
    if (e) {
      filteredList.push(id);
    }
    setCheckboxes(filteredList);
  };

  const toggleCheckboxes = (val) => {
    setCheckboxes(
      val ? createdCosRiviewInvoiceToMap.map((t) => t.id) : []
    );
  };

  useEffect(() => {
    if (
      createdCosRiviewInvoiceToMap &&
      checkboxes.length > 0 &&
      checkboxes.length === createdCosRiviewInvoiceToMap.length &&
      createdCosRiviewInvoiceToMap.length !== 0
    ) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  }, [checkboxes, createdCosRiviewInvoiceToMap]);

  useEffect(() => {
    getCosInvoiceMode();
  }, [getCosInvoiceMode]);

  useEffect(() => {
    if (!isOldBatch) return;
    if (updatedAction && checkboxes.length > 0) {
      handleChangeAction();
    }
  }, [updatedAction, checkboxes, isOldBatch]);

  useEffect(() => {
    if (!isOldBatch) return;
    if (
      createdCosRiviewInvoiceToMap.length === 0 &&
      changeCaseNotesInvoiceStatusSuccess
    ) {
      navigate("/ah/invoice");
    }
  }, [createdCosRiviewInvoiceToMap, changeCaseNotesInvoiceStatusSuccess, isOldBatch, navigate]);

  useEffect(() => {
    if (!isOldBatch || !changeCaseNotesInvoiceStatusSuccess) return;
    getInvoicesList({
      id: uuid,
      status: statusSelect ? statusSelect.value : "all",
      pt_id: selectedClient ? selectedClient.value : "all",
    });
  }, [
    changeCaseNotesInvoiceStatusSuccess,
    isOldBatch,
    uuid,
    getInvoicesList,
    statusSelect,
    selectedClient,
  ]);

  const getText = () => {
    if (updatedAction === "revert") {
      return "Are you sure you want to Revert these case notes";
    }
    if (updatedAction === "cancelled") {
      return "Are you sure you want to cancel these case notes";
    }
    if (updatedAction === "extract_generated") {
      return "Are you sure you want to undo cancel these case notes";
    }
    if (updatedAction === "provider_paid") {
      return "Are you sure you want to Change the action to  Provider Paid";
    }
    if (updatedAction === "xero") {
      return "Are you sure you want to Export on Xero";
    }
    if (updatedAction === "email_invoice") {
      return "Are you sure you want to email the invoice?";
    }
    return "Are you sure?";
  };

  const handleChangeAction = async () => {
    if (isUserGracePeriodOver) return;
    if (
      updatedAction &&
      checkboxes.length > 0 &&
      (updatedAction === "pdf" || updatedAction === "xlsx")
    ) {
      try {
        setFileDownloaderLoader(true);
        const res = await api.changeActionsClaimInvoiceApi({
          report: updatedAction,
          cos_invoice_ids: checkboxes,
        });
        if (res && res.report) {
          await FileSaver.saveAs(
            res.report.download_url,
            `Invoices-${updatedAction === "xlsx" ? "EXCEL" : "PDF"}-File${
              updatedAction === "xlsx" ? ".csv" : ".pdf"
            }`
          );
        }
        setCheckboxes([]);
        setUpdatedAction("");
        setFileDownloaderLoader(false);
      } catch (err) {
        setUpdatedAction("");
        setFileDownloaderLoader(false);
        console.log("err", err);
        toast.error("Something went wrong while downloading!");
      }
      return;
    }
    swal({
      title: "Confirm your action?",
      text: getText(),
      icon: "",
      buttons: ["No, take me back!", "Yes, go ahead!"],
      dangerMode: updatedAction === "cancelled",
    }).then((willDelete) => {
      if (isUserGracePeriodOver) return;
      if (willDelete && checkboxes.length > 0) {
        changeInvoiceStatus({
          status: updatedAction,
          cos_invoice_ids: checkboxes.map((x) => String(x)),
        });
        setCheckboxes([]);
        setUpdatedAction("");
      } else {
        setCheckboxes([]);
        setUpdatedAction("");
      }
    });
  };

  useEffect(() => {
    getClientsRequest();
    return () => emptyTableData();
  }, []);

  useEffect(() => {
    if (!cosInvoiceLoading && renderLoading !== LOADER_STATUS.NA) {
      setRenderLoading(LOADER_STATUS.COMPLATE);
    }
  }, [cosInvoiceLoading]);

  useEffect(() => {
    getInvoicesList({
      id: uuid,
      status: statusSelect ? statusSelect.value : "all",
      pt_id: selectedClient ? selectedClient.value : "all",
    });
  }, [statusSelect, selectedClient]);

  useEffect(() => {
    if (
      createdCosReviewInvoiceDeliveryStatus &&
      createdCosReviewInvoiceDeliveryStatus
    ) {
      createdCosReviewInvoiceDeliveryStatus.unshift({
        label: "All",
        value: "all",
      });
    }
  }, [createdCosReviewInvoiceDeliveryStatus]);

  useEffect(() => {
    if (createdCosReviewInvoiceClients && createdCosReviewInvoiceClients) {
      createdCosReviewInvoiceClients.unshift({ label: "All", value: "all" });
    }
  }, [createdCosReviewInvoiceClients]);

  return (
    <div className='min-h-full min-w-0'>
      <SideBar />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        } flex min-h-screen min-w-0 flex-col`}
      >
        <main className='flex w-full min-w-0 flex-1 flex-col bg-white pb-10'>
          <Header
            title='Invoice Preview'
            breadcrumb={
              <Breadcrumb
                pages={AH_BREADCRUMB(AH_BREADCRUMB_PAGES.AH_INVOICE_REVIEW)}
              />
            }
          />
          <div className='w-full min-w-0 bg-white px-3 py-3 sm:px-4'>
            <div className='sticky z-[60] my-3 flex flex-col gap-4 bg-white py-2 sm:flex-row sm:flex-wrap sm:items-end sm:justify-between top-[80px]'>
              <div className='grid min-w-0 w-full grid-cols-1 gap-3 sm:grid-cols-2 lg:flex-1'>
                <div className='min-w-0'>
                  <label className='block text-start text-sm font-medium text-gray-700 text-start'>
                    Participant
                  </label>
                  <SelectOption
                    isClearable={true}
                    isDisabled={
                      createdCosInvoiceReviewLoading ||
                      (isOldBatch && changeNDISCaseNotesInvoiceStatusLoading)
                    }
                    cssClass=''
                    name='client'
                    isSearch={false}
                    data={
                      createdCosReviewInvoiceClients &&
                      createdCosReviewInvoiceClients
                    }
                    selectedOption={selectedClient}
                    handleChange={(e) => {
                      setSelectedClient(e);
                    }}
                  />
                </div>
                <div className='min-w-0'>
                  <label className='block text-start text-sm font-medium text-gray-700 text-start'>
                    Status
                  </label>
                  <SelectOption
                    isClearable={true}
                    isDisabled={
                      createdCosInvoiceReviewLoading ||
                      (isOldBatch && changeNDISCaseNotesInvoiceStatusLoading)
                    }
                    cssClass=''
                    name='sp_cos_id'
                    isSearch={false}
                    data={
                      createdCosReviewInvoiceDeliveryStatus &&
                      createdCosReviewInvoiceDeliveryStatus
                    }
                    selectedOption={statusSelect}
                    handleChange={(e) => {
                      setStatus(e);
                    }}
                  />
                </div>
              </div>
              {isOldBatch && (
                <div className='relative z-[70] flex w-full min-w-0 shrink-0 justify-end sm:w-auto'>
                  <SelectBox
                    disabled={
                      (checkboxes.length > 0 ? false : true) || isUserGracePeriodOver
                    }
                    setUpdatedAction={setUpdatedAction}
                    setClientHoursReport={setClientHoursReport}
                    setCosHoursReport={setCosHoursReport}
                    isForCosModule={false}
                    allowXeroExport={!isWorkerBlackPortal}
                    allowEmailInvoice={true}
                    showExportReports={true}
                  />
                </div>
              )}
            </div>
            <div className='min-w-0'>
              <div className='flex flex-col'>
                <div className='-my-2 min-w-0'>
                  <div className='min-w-0 py-2 align-middle'>
                    <div className='max-w-full overflow-x-auto overflow-y-visible rounded-lg border border-gray-200 shadow-sm ring-1 ring-black ring-opacity-5'>
                      <table className='w-full min-w-[1024px] table-fixed divide-y divide-gray-300 capitalize'>
                        <thead className='bg-blue-50 capitalize'>
                          <tr>
                            {isOldBatch && (
                              <th
                                scope='col'
                                className='w-[3%] min-w-0 bg-blue-50 px-1 py-3.5 text-center text-base font-semibold text-gray-900'
                              >
                                <CheckBox
                                  isDisabled={isUserGracePeriodOver}
                                  checked={allSelected}
                                  handleChange={(e) => {
                                    if (isUserGracePeriodOver) {
                                      return;
                                    }
                                    if (
                                      createdCosRiviewInvoiceToMap &&
                                      createdCosRiviewInvoiceToMap.length > 0
                                    ) {
                                      toggleCheckboxes(e);
                                    }
                                  }}
                                />
                              </th>
                            )}

                            <TableHeader
                              isSort={false}
                              label={"Reference"}
                              innerCssClass='truncate'
                              cssClass='w-[6%] min-w-0 px-3 py-3.5 text-left text-base font-semibold text-gray-900'
                            />
                            <TableHeader
                              isSort={false}
                              label={"Created By"}
                              innerCssClass='truncate'
                              cssClass='w-[6%] min-w-0 px-3 py-3.5 text-left text-base font-semibold text-gray-900'
                            />
                            <TableHeader
                              isSort={false}
                              label={participantLabel}
                              innerCssClass='truncate'
                              cssClass='w-[10%] min-w-0 px-3 py-3.5 text-left text-base font-semibold text-gray-900'
                            />
                            <TableHeader
                              isSort={false}
                              label={"Mgmt Style"}
                              innerCssClass='truncate'
                              cssClass='w-[8%] min-w-0 px-3 py-3.5 text-left text-base font-semibold text-gray-900'
                            />
                            <TableHeader
                              isSort={false}
                              label={"Support Item"}
                              innerCssClass='truncate'
                              cssClass='w-[11%] min-w-0 px-3 py-3.5 text-left text-base font-semibold text-gray-900'
                            />
                            <TableHeader
                              isSort={false}
                              label={"Support Item Number"}
                              innerCssClass='truncate'
                              cssClass='w-[7%] min-w-0 px-3 py-3.5 text-left text-base font-semibold text-gray-900'
                            />
                            <TableHeader
                              isSort={false}
                              label={"Status"}
                              innerCssClass='truncate'
                              cssClass='w-[6%] min-w-0 px-3 py-3.5 text-left text-base font-semibold text-gray-900'
                            />
                            <TableHeader
                              isSort={false}
                              label={"Date Delivered"}
                              innerCssClass='truncate'
                              cssClass='w-[12%] min-w-0 px-3 py-3.5 text-left text-base font-semibold text-gray-900'
                            />
                            <TableHeader
                              isSort={false}
                              label={"Km"}
                              innerCssClass='truncate'
                              cssClass='w-[4%] min-w-0 px-3 py-3.5 text-right text-base font-semibold text-gray-900'
                            />
                            <TableHeader
                              isSort={false}
                              label={"Hours"}
                              innerCssClass='truncate'
                              cssClass='w-[5%] min-w-0 px-3 py-3.5 text-right text-base font-semibold text-gray-900'
                            />
                            <TableHeader
                              isSort={false}
                              label={"Rate"}
                              innerCssClass='truncate'
                              cssClass='w-[5%] min-w-0 px-3 py-3.5 text-right text-base font-semibold text-gray-900'
                            />
                            <TableHeader
                              isSort={false}
                              label={"Total Amount"}
                              innerCssClass='truncate'
                              cssClass='w-[8%] min-w-0 px-3 py-3.5 text-right text-base font-semibold text-gray-900'
                            />
                          </tr>
                        </thead>
                        <tbody className='divide-y divide-gray-200 bg-white'>
                          {fileDownloaderLoader ||
                          createdCosInvoiceReviewLoading ||
                          (isOldBatch && changeNDISCaseNotesInvoiceStatusLoading) ? (
                            <tr>
                              <td
                                colSpan={isOldBatch ? 13 : 12}
                                className='bg-gray-50 py-2'
                              >
                                <CircularLoader
                                  classes='flex justify-center items-center'
                                  classloader='loader-l'
                                />
                              </td>
                            </tr>
                          ) : createdCosRiviewInvoiceToMap &&
                            createdCosRiviewInvoiceToMap.length > 0 ? (
                            createdCosRiviewInvoiceToMap.map((item, index) => (
                              <COSInvoiceTabel
                                item={item}
                                key={index}
                                isUserGracePeriodOver={isUserGracePeriodOver}
                                showRowCheckbox={isOldBatch}
                                checkboxes={checkboxes}
                                handleCheckboxChange={handleCheckboxChange}
                              />
                            ))
                          ) : (
                            (!createdCosRiviewInvoiceToMap ||
                              createdCosRiviewInvoiceToMap.length === 0) && (
                              <tr>
                                <td
                                  colSpan={isOldBatch ? 13 : 12}
                                  className='py-6 text-center text-red-600'
                                >
                                  No Data Found !
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default COSInvoicePreviewPage;
